<script setup lang="ts">
defineProps<{
  icons?: {
    icon: StoryBlokIcon
  }[]
  title: string
  placeholder: string
  button: StoryBlokButton[]
  secondaryButton?: StoryBlokButton[]
  mask: { mask: string | RegExp }
  countryCode: string
}>()

const emit = defineEmits(['click'])

const form = ref()
</script>

<template>
  <div class="h-full rounded-xl p-4 md:p-5 flex flex-col justify-center gap-2.5 bg-white shadow-form md:w-[315px]">
    <div v-if="icons?.length" class="flex gap-2 <sm:hidden">
      <AppIcon v-for="icon in icons" v-bind="icon.icon" size="40" class="text-primary" />
    </div>
    <h3 v-html="title" />
    <!-- Klik calculator have different params for nospz ... so, no value, returns empty string -->
    <FormSimple
      ref="form"
      class="flex flex-col gap-2.5"
      @submit="emit('click', form?.values?.licensePlate || '', 'spz')"
    >
      <FormFieldText
        name="licensePlate"
        :mask="mask"
        :placeholder="placeholder"
        disable-storyblok
      >
        <template #start>
          <div class="bg-[#003399] flex items-center justify-center p-2.2 rounded-l-[9px]">
            <div class="flex-col items-center">
              <nuxt-icon name="core/euStars" filled class="text-xs" />
              <div class="text-white text-[12px] pt-0.5">
                {{ countryCode }}
              </div>
            </div>
          </div>
        </template>
      </FormFieldText>
      <StoryblokButton v-if="button?.length" v-editable="button[0]" v-bind="button[0]" submit />
    </FormSimple>
    <StoryblokButton v-if="secondaryButton?.length" v-editable="secondaryButton[0]" v-bind="secondaryButton[0]" />
  </div>
</template>
